import {
  ThreadIcon_default
} from "./chunk-CF44NBY3.mjs";
export {
  ThreadIcon_default as default
};
